// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rule_row[data-v-a9a367d6]:nth-child(2n){background-color:rgba(24,124,198,.1)}.rule-list[data-v-a9a367d6]{margin-bottom:15rem!important}.massEditStyle[data-v-a9a367d6],.rule-list[data-v-a9a367d6]{box-shadow:0 1px 3px rgba(0,0,0,.12),0 -1px 5px rgba(0,0,0,.24)}.massEditStyle[data-v-a9a367d6]{margin-top:3px}", ""]);
// Exports
module.exports = exports;
